module.exports = __webpack_public_path__ + "img/028c72f.jpg";